import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AssessmentAnswerInterface, AssessmentQuestionInterface } from 'app/assessment/models';
import { DynamicQuestionComponent } from 'app/assessment/questions/dynamic-question-content/dynamic-question.component';
import { getDeepCopyOfObject } from 'app/shared/utilities/utility-methods.utility';

@Component({
  selector: 'cz-multi-text-input',
  templateUrl: './multi-text-input.component.html',
  styleUrls: ['./multi-text-input.component.scss'],
})
export class MultiTextInputComponent extends DynamicQuestionComponent implements OnInit {
  @Input() public readonly type: string;
  @Input() public readonly question: AssessmentQuestionInterface;
  @Input() public readonly form: FormGroup;
  @Input() public readonly imagePath: string;
  @Input() public readonly parentQuestion: AssessmentQuestionInterface;
  @Input() public readonly readOnly: boolean;

  constructor() {
    super();
  }

  public ngOnInit():void {
  }

  public isFieldValid(field: string): boolean {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  public displayFieldCss(field: string): {} {
    return {
      'error-msg': this.isFieldValid(field),
    };
  }

  public onKeyPress(value: string, formGroupName: string, formControlName: string, answer: AssessmentAnswerInterface): void {
    const formGroup: FormGroup = this.form.controls[this.type] as FormGroup;
    const updatedAnswer: AssessmentAnswerInterface = getDeepCopyOfObject(answer);
    updatedAnswer.text = value.toString();

    if (formGroupName) {
      (formGroup.controls[formGroupName] as FormGroup).controls[formControlName].setValue(updatedAnswer);
    } else {
      formGroup.controls[formControlName].setValue(updatedAnswer);
    }

    formGroup.markAsDirty();
  }

  public createFormControlName(parentQuestion: AssessmentQuestionInterface, question: AssessmentAnswerInterface): string {
    if (parentQuestion) {
      return `${parentQuestion.id}-${question.id}`;
    }
    return question.id.toString();
  }
}
